import React from 'react'
import styled from 'styled-components'
import { Box, Text } from 'grommet'
import { LogoLabel } from '../index'

const Logo = ({ screenSize, theme, showLogo, companyName, logoLabel, logoStyle, ...rest }) => {
  return (
    <Box 
      direction="row" 
      alignContent="start" 
      justify="center"
      margin={{ right: screenSize }}
      responsive={false}
    >
      {
        showLogo && <LogoIcon theme={theme} style={logoStyle} />
      }
      <LogoText
        a11yTitle="Hippobyte Logo"
        alignSelf="center"
        color={theme === "dark" ? "dark-3" : "light-0"}
        margin={ companyName && logoLabel && { right: "0.5em" }}
        {...rest}
      >
        {companyName}
      </LogoText>
      {
        logoLabel && <LogoLabel label={logoLabel} />
      }
    </Box>
  )
}

Logo.defaultProps = {
  showLogo: true,
  companyName: "Hippobyte",
  logoLabel: null
}

const LogoIcon = ({ theme, style }) => (
  <svg 
    id="HippobyteLogo" 
    data-name="hippobyte-logo" 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 941.14 994.4"
    width="48px"
    height="36px"
    fill={theme === "dark" ? "#4C5FE8" : "#F6F7FC"}
    style={{ width: "54px", marginRight: "10px", ...style }}
  >
    <title>Hippobyte</title>
    <g id="logo">
      <path d="M271.13,650.51c5.75,17.31,28.8,25.24,51.48,17.7s36.4-27.68,30.65-45-28.8-25.23-51.48-17.69S265.37,633.2,271.13,650.51ZM313.82,644c7.16-2.38,13.77-1.9,14.76,1.1s-4,7.32-11.17,9.7-13.77,1.9-14.76-1.09S306.66,646.37,313.82,644Z" transform="translate(-59.67 -9.6)"/>
      <path d="M962,417.94C934,353.53,893.9,297.56,844.2,248.15,781.78,186.07,710.51,136.83,630.75,99.77,616.51,93.16,602,87.08,585,79.59c5.08-4.11,9.24-6.77,12.55-10.25,15.21-16,14.45-41.2-1.77-52-13.25-8.8-28.32-10.29-42.27-3.54-35.36,17.12-52.83,48.92-59.9,85.11-10.43,53.47,0,104.61,26.25,152.44,24.14,43.92,60.9,76,99.42,106.46,36.83,29.11,76.59,54.8,107.57,90.77,41,47.65,52.89,101.68,30.68,160.85-17.54,46.76-50.17,76-90.9,89.35l-1.32,31.9a12.67,12.67,0,0,1-13.14,12.11l-33.92-1.4a12.68,12.68,0,0,1-12.1-13.15l.86-21c-13.07-.26-26.18-1.71-39.3-2.8-6,10.29-35.66,21.61-72.35,26.87-32,4.6-60.09,3.27-72.54-2.55-8.61,4.9-17,10.22-25.36,15.61q-7.71,5-15.46,9l8.31,21.15A12.69,12.69,0,0,1,383.17,791l-31.6,12.42a12.7,12.7,0,0,1-16.39-7.14L325,770.39q-40.27,3.12-81.55-18.28c-55.65-29-76.14-81.44-72.25-133.45,2.72-36.36,17.11-68.87,36.54-99.09,21.1-32.81,43.73-64.65,64.67-97.55,29.46-46.29,41.06-96.14,28.36-150.76-8.75-37.67-27.76-68-61.17-87.62-21.72-12.76-45.1-22.11-71.37-13.69-15.79,5.08-22.88,15.27-21.12,30.48,1.49,12.95,11.51,21.89,26.5,23.54,4.19.46,8.4.68,14.78,1.19-4.57,4.15-6.9,6.64-9.6,8.65C131.62,269,112.49,334.68,136.1,390.63c7.67,18.14,4.64,31.94-5.48,47.35-39,59.38-63.94,123.63-69.42,195.38C57.82,677.65,59.73,721,70,764.14c19.92,83.82,63.59,152.29,132.7,204,30.36,22.72,63,38.24,102.79,35.51,28-1.92,56.19-1.26,84.23-.12,31.34,1.28,38.88-14.86,41.56-39.43.41-3.75-.09-7.59.1-11.37,2.18-42.78,26.18-77.22,75.89-77.52,35.17-.22,60.53,13.9,70,43.06,4.47,13.77,5.21,28.86,6.66,43.45,2.79,27.9,8.24,42.89,42,41.84,39.44-1.21,79,.23,118.41-.64a94.26,94.26,0,0,0,33.9-7.23c47.11-20,84.64-53,117.28-91.41,66.66-78.45,99.45-170.63,104.63-272.58C1003.9,557.83,991.64,486.18,962,417.94ZM576.84,209.27a54,54,0,0,1-18.3-3.91,9.85,9.85,0,0,1,6.33-5.85c5.07-1.6,10.35.85,11.82,5.46A8.28,8.28,0,0,1,576.84,209.27ZM594,205.42a51.7,51.7,0,0,1-7.25,2.4,18.89,18.89,0,0,0,4-18c-3.22-10.19-14.88-15.59-26.06-12.07-10.7,3.38-17.05,13.71-14.75,23.54a31.21,31.21,0,0,1-9.6-12.51c-7.66-18.36,3.9-40.68,25.83-49.85s45.94-1.7,53.62,16.66S615.91,196.26,594,205.42ZM243.51,331.72a9.27,9.27,0,0,1-1.7.52l-.08,0a3.5,3.5,0,0,1-1.46-1.89,3.67,3.67,0,0,1-.16-1,4,4,0,0,1,2.91-3.72,4.23,4.23,0,0,1,2.77.05,3.59,3.59,0,0,1,2.21,2.24h0s0,0,0,.05A9.09,9.09,0,0,1,243.51,331.72Zm-24.69-43c15.26-6.22,32-1.16,37.31,11.3,2.79,6.51,1.92,13.77-1.74,20.1,0-.07,0-.12,0-.18-.1-.3-.2-.58-.31-.87s-.22-.5-.34-.75-.26-.52-.4-.76-.3-.49-.46-.72a13.27,13.27,0,0,0-7.42-5.35,15.8,15.8,0,0,0-5.89-.53l-.37.05c-.33,0-.67.09-1,.16a15.12,15.12,0,0,0-1.79.45,7.7,7.7,0,0,0-1,.35.74.74,0,0,0-.21.07,7.56,7.56,0,0,0-.76.33,2.37,2.37,0,0,0-.36.17c-.31.15-.62.31-.92.49s-.43.25-.64.39a14.27,14.27,0,0,0-1.19.85c-.26.2-.52.42-.77.65l-.73.7-.08.08c-.23.25-.46.5-.67.75s-.44.55-.64.83-.4.58-.58.88-.36.6-.52.9l-.28.58a4.93,4.93,0,0,0-.22.53.24.24,0,0,0-.05.1l-.21.55a14.07,14.07,0,0,0-.39,1.37c-.06.3-.12.58-.16.88l-.07.44c0,.14,0,.28,0,.43a12,12,0,0,0,.49,4.81,12.37,12.37,0,0,0,2.22,4.09,12.85,12.85,0,0,0,3.37,2.89c-13.37,2.84-26.53-2.39-31.15-13.19C195.51,310.13,203.56,295,218.82,288.77Z" transform="translate(-59.67 -9.6)"/>
      <path d="M680,553.73c0-18.24-19.37-33-43.27-33s-43.28,14.79-43.28,33,19.38,33,43.28,33S680,572,680,553.73Zm-45.78,19.35c-7.55-.3-13.55-3.1-13.42-6.25s6.35-5.43,13.89-5.13,13.55,3.12,13.42,6.26S641.79,573.4,634.25,573.08Z" transform="translate(-59.67 -9.6)"/>
    </g>
  </svg>
)

const LogoText = styled(Text)`
  font-family: 'Cantarell', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 2px;
  text-transform: uppercase;
`

export default Logo